import React, { useEffect, useState } from "react";
import { FiX } from "react-icons/fi";
import editorStore from "../../stores/EditorStore";
import loadingSpinner from "../../assets/img/Spinner.svg";

/** The design as it will print: full page including bleed, without the editor's guides. */
const BannerPreview: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const [src, setSrc] = useState("");

  useEffect(() => {
    // toDataURL hides every showInExport:false object (page border, bleed and safety guides)
    editorStore.toDataURL().then(setSrc);
  }, []);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-8" onClick={onClose}>
      <div className="relative flex max-h-full max-w-full flex-col rounded-lg bg-white p-4 shadow-xl" onClick={e => e.stopPropagation()}>
        <div className="mb-3 flex items-center justify-between font-jakarta">
          <h2 className="text-sm font-bold text-ink">Preview</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-800" title="Close"><FiX size={18} /></button>
        </div>
        {src
          ? <img src={src} alt="Banner preview" className="max-h-[75vh] max-w-[85vw] border border-gray-200 object-contain" />
          : <img src={loadingSpinner} alt="Loading..." className="m-12 h-16 w-16" />}
      </div>
    </div>
  );
};

export default BannerPreview;
